import { render, staticRenderFns } from "./ArtistPassportInformation.vue?vue&type=template&id=fccd1404&scoped=true"
import script from "./ArtistPassportInformation.vue?vue&type=script&lang=js"
export * from "./ArtistPassportInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccd1404",
  null
  
)

export default component.exports